export default __webpack_public_path__ + "styles/Loader.c379e61fc2a12e1edd46a16aa6aae81a.css";